export const splitText = (text: string): string[] => {
  const regex = /[А-Яа-яЁё]+\s+[0-9]*/g;
  return text.match(regex);
};
